import { Party } from './party';
import { Abstract } from './abstract';
import { JuvenileCase } from './../juvenile-case';
import { SafeJSON } from './../../shared/safe-json';

export class ServiceOfDocuments {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
     }
    getKey(): string {
        return this.key;
    }
    getPartyCode(): string {
        return SafeJSON.getWithDefault('partyRef', this.json);
    }
    getPartyNameByPartyRef(juvenileCase: JuvenileCase): string {
        const party = juvenileCase.getpartyMap().get(this.getPartyCode());
        if (party === undefined) {
            return '-';
        }
        return party.getName();
    }
    getTypeOfServedDocument(juvenileCase: JuvenileCase): string {
        const field = SafeJSON.getWithDefault('serviceTypeDesc', this.json);
        if (field === '-') {
            return '-';
        }
        return field;
    }
    getTypeOfServedDocumentForAbstracts(juvenileCase: JuvenileCase): string {
        const abstractRef = SafeJSON.get('abstractRef', this.json);
        if (abstractRef === '') {
            return '';
        }
        const abstract: Abstract = juvenileCase.getAbstractByKey(abstractRef);
        if (abstract === undefined) {
            return '';
        }
        return abstract.getAbstractSectionTitle(true) + ' ' + abstract.getAbstractJudgmentNumber();
    }
    getIssuedOnDate(): string {
        /* we get
            "issueDate": "2004-01-28",
			"issueHour": "13:00",
           we need this format:  2004-02-12T16:37:20.125405
         */
        const issueDate = SafeJSON.get('issueDate', this.json);
        const issueHour = SafeJSON.get('issueHour', this.json);
        const issueDateTime = issueDate + 'T' + issueHour + ':00.000000';
        if (issueDate === '' || issueHour === '') {
            return '';
        }
        return issueDateTime;
    }
    getStatusOfService(): string {
        return SafeJSON.getWithDefault('serviceReasonReturnedDesc', this.json);
    }
    getMethodOfService(): string {
        return SafeJSON.getWithDefault('serviceVehicleDesc', this.json);
    }
    getServedOnDate(): string {
        return SafeJSON.get('serveDateTime', this.json);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/serviceOfDocuments.ts